// Türkçe (tr), zamanlayıcı: zelfde vorm als kioskTimer.nl.ts.
export const kioskTimerTr = {
    open: 'Zamanlayıcı',
    openRunning: 'Zamanlayıcı: {time} kaldı',
    title: 'Zamanlayıcı',
    minutes: '{n} dk',
    custom: 'Kendin seç',
    less: 'Bir dakika az',
    more: 'Bir dakika fazla',
    minutesUnit: 'dakika',
    forWhat: 'Ne için?',
    labels: {
        teeth: 'Diş fırçalama',
        homework: 'Ödev',
        screen: 'Ekran süresi',
        cooking: 'Yemek',
    },
    start: 'Başlat',
    left: '{time} kaldı',
    paused: 'Duraklatıldı',
    pause: 'Duraklat',
    resume: 'Devam',
    plusOne: '+1 dk',
    stop: 'Durdur',
    done: 'Süre doldu!',
    /** Rustig, buiten het thema Kinderen. */
    doneCalm: 'Süre doldu',
};
//# sourceMappingURL=kioskTimer.tr.js.map